import React, { createContext, ReactElement, useContext } from 'react';
import { IJobFieldSettings } from 'wisestep-api';

import useListingSettings from '../../features/jobs/listing/hooks/useListingSettings';

export const JobsListContext = createContext<IJobFieldSettings | null>(null);

interface JobsListContextProviderProps {
  children: ReactElement;
}

export default function JobsListContextProvider({ children }: JobsListContextProviderProps) {
  const { jobFieldSettings } = useListingSettings();
  return (
    <JobsListContext.Provider value={{ ...jobFieldSettings }}>{children}</JobsListContext.Provider>
  );
}

export function useJobSettingsContext() {
  const context = useContext(JobsListContext);
  if (!context) {
    throw new Error('useAppState must be used within the JobsListContextProvider');
  }
  return context;
}
